export default [
    'company.company_name',
    'company.company_number',
    'company.crefo_id',
    'company.annual_turnover',
    'company.website',
    'company.type',
    'company.registered.mm',
    'company.registered.yy',

    'company.address.building_number',
    'company.address.street_line_1',
    'company.address.street_line_2',
    'company.address.postcode',
    'company.address.town'
];
